export default "__VITE_ASSET__660b1ab7__"